
// CORE
import React from 'react';
import PropTypes from 'prop-types';

// MUI
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';

// Data
import { useSelector, useDispatch } from 'react-redux'
import { getScheduledTransactionById } from 'data/scheduledTransactions/scheduledTransactionsSelectors';
import { mkScheduledTransaction } from 'data/scheduledTransactions/scheduledTransactionsTypes';
import { deleteScheduledTransaction } from 'data/scheduledTransactions/scheduledTransactionsActions';
import { removeDialog } from 'data/rootUi/actions';

// Custom
import QButton from 'components/QButton';
import useQData from 'components/QData/useQData';


const useStyles = makeStyles((_theme) => ({
  closeButton: {
    position: 'absolute',
    top: 6,
    right: 6,
    zIndex: '1',
  },
  content: {
    width: 520,
    padding: 24,
  },
  bottomRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
    paddingLeft: 12,
  },
  buttonGroup: {
    display: 'flex',
  },
}));


const DeleteReminderDialog = (props) => {
  const classes = useStyles();

  const { txn } = props;
  const dispatch = useDispatch();

  const { qDataPerformTransactionAction } = useQData();
  const model = useSelector((state) => getScheduledTransactionById(state, txn.stModelId));

  function onClose() {
    dispatch(removeDialog());
  }

  // data stuff
  const actOnScheduledTxn = (action) => {
    const actionObj = {
      id: txn.id,
      action,
      overdueAction: action,
      instanceDate: txn.stDueOn,
    };
    qDataPerformTransactionAction(actionObj);
  };
  const deleteInstance = () => {
    actOnScheduledTxn('SKIP');
    onClose();
  };

  const deleteModel = () => {
    if (!model) {
      actOnScheduledTxn('SKIP');
    } else {
      dispatch(deleteScheduledTransaction(mkScheduledTransaction({
        id: txn.stModelId,
        ...model.toJS,
        isUserVerified: true,
      })));
    }
    onClose();
  };

  return (
    <Dialog
      open
      aria-labelledby="survey"
      onClose={onClose}
    >
      <IconButton
        className={classes.closeButton}
        aria-label="Close"
        id="recurring-dialog-close"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle id="important-message-dialog-title">
        Delete Reminder
      </DialogTitle>

      <DialogContent className={classes.content}>
        <Typography variant="subtitle1">
          {`Are you sure you want to delete the reminder for "${txn.payee}"?`}
        </Typography>
      </DialogContent>

      <div className={classes.bottomRow}>
        <QButton onClick={deleteModel}>
          Delete Series
        </QButton>

        <div className={classes.buttonGroup}>
          <QButton variant="outlined" onClick={onClose}>
            Cancel
          </QButton>
          <QButton variant="contained" width={140} style={{ marginLeft: 16 }} onClick={deleteInstance}>
            Delete
          </QButton>
        </div>
      </div>
    </Dialog>
  );
};

DeleteReminderDialog.defaultProps = {
  txn: {},
};

DeleteReminderDialog.propTypes = {
  txn: PropTypes.object,
};

export default DeleteReminderDialog;
